import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const GetAll = createAsyncThunk(
  "customer-management/customer-management/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.CustomerManagement.GetAllCustomer
        }?unique_id=${filter?.unique_id || ""}&email=${filter?.email ||
          ""}&organization_name=${filter?.organization_name ||
          ""}&contact_person_name=${filter?.contact_person_name ||
          ""}&customer_status_id=${filter?.customer_status_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date ||
          ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSingle = createAsyncThunk(
  "customer-management/customer-management/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.CustomerManagement.GetAllCustomer}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const CreateCustomer = createAsyncThunk(
  "customer-management/customer-management/createcustomer",

  async (data, { rejectWithValue }) => {
    console.log("this is called");
    try {
      const res = await POST(APIS.CustomerManagement.PostCutomerDetails, data);

      console.log("resresresres", res);
      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);
export const GetSampleById = createAsyncThunk(
  "customer-management/customer-management/get-samples",

  async ({ id, page, per_page }, { rejectWithValue }) => {
    console.log("this is called");
    try {
      const res = await GET(
        `${APIS.CustomerManagement.GetSampleById}/${id}?page=${page ||
          IDS.PAGE}&per_page=${per_page || IDS.PERPAGE}`,
      );

      // console.log("resresresres",res)
      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

export const CreateOrganization = createAsyncThunk(
  "customer-management/customer-management/createorganaization",

  async (data, { rejectWithValue }) => {
    console.log("this is called");
    try {
      const res = await POST(
        APIS.CustomerManagement.PostOrganizationDetails,
        data,
      );

      console.log("resresresres", res);
      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

export const Update = createAsyncThunk(
  "customer-management/customer-management/update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.CustomerManagement.UpdateDetails}/${id}`,
        sendData,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const Delete = createAsyncThunk(
  "customer-management/customer-management/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.UserManagement.Roles}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StatusRole = createAsyncThunk(
  "customer-management/customer-management/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.UserManagement.Roles}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const SampleInvoiceGenerate = createAsyncThunk(
  "customer-management/customer-management/invoice-generate",

  async (data, { rejectWithValue }) => {
    console.log(data, "this is called");
    try {
      const res = await POST(APIS.CustomerManagement.SampleGenerate, data);

      console.log("resresresres", res);
      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

export const SampleInvoiceGenerateEdit = createAsyncThunk(
  "customer-management/customer-management/invoice-generate-edit",

  async ({data,id}, { rejectWithValue }) => {
    try {
      console.log(data,'data data');
      
      // if (data?.id) {
        const res = await PUT(
          `${APIS.CustomerManagement.SampleGenerate}/${id}`,
          data,
        );

        return res;
      // }
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);
export const Slice = createSlice({
  name: "customerManagement",
  initialState: {
    data: [],
    sample_data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSampleById.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSampleById.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.sample_data = action.payload?.data || [];
      })

      .addCase(GetSampleById.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CreateCustomer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateCustomer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(CreateCustomer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(CreateOrganization.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateOrganization.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(CreateOrganization.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SampleInvoiceGenerate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SampleInvoiceGenerate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(SampleInvoiceGenerate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SampleInvoiceGenerateEdit.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SampleInvoiceGenerateEdit.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(SampleInvoiceGenerateEdit.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (role) => role.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusRole.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusRole.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(StatusRole.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
